export default {
  checklist: (payload) =>
    `checklist?category=${payload.category}&type=${payload.type}`,
  categoryDisclaimer: (payload) =>
    `checklist/disclaimer?documentNo=${payload.category}&disclaimerType=${payload.type}`,
};
